import styled, { css } from 'styled-components';

import { elevation, elevationTransition, transition } from 'ggApp/utils/mixins';

import CommonContainer from 'ggApp/shared/common/Container';
import SearchSuggestions from './SearchSuggestions';
import ExpandedContent from './ExpandedContent';

const OuterWrap = styled(CommonContainer)`
    width: 100%;
    -webkit-tap-highlight-color: transparent;
    * {
        -webkit-tap-highlight-color: transparent;
    }
`;

const InnerWrap = styled.div`
    width: 100%;
    position: absolute;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    background-color: ${({ theme }) => theme.colors.ElementBackground};
    border-radius: 24px;
    cursor: text;
    ${elevation(1, false)};
    ${({ theme }) => theme.superQuery.all.and.maxWidth.mobileMax.css`
        z-index: 1;
        ${({ overlayIsOpen }) => overlayIsOpen && css`
        position: fixed;
        border-radius: 0;
        top: 0;
        left: 0;
        right: 0;
            ${elevation(0, false)}
        `}
    `}
    ${({ theme }) => theme.superQuery.all.and.minWidth.tabletMin.css`
        ${elevationTransition(false)}
        ${({ overlayIsOpen }) => overlayIsOpen && css`
            ${elevation(3, false)};
        `}
        &:focus-within, &:focus {
            color: black;
            border-color: white;
            ${elevation(2, false)}
        }
        &:hover {
            color: black;
            border-color: white;
            ${elevation(3, false)}
        }
    `}
`;

const Form = styled.form`
    height: 48px;
    padding: 0 12px;
    width: 100%;
    overflow: hidden;
    display: flex;
    align-items: center;
    position: relative;
    flex: 0 0 auto;
    ${({ overlayIsOpen }) => overlayIsOpen && css`
        border-bottom: 2px solid ${({ theme }) => theme.colors["Level 1"]};
    `}
`;

const Input = styled.input`
    margin-left: 8px;
    height: 100%;
    flex-grow: 1;
    max-width: calc(100% - 26px);
    ${({ theme }) => css(theme.typography.SuperTinyHeadline)};
    color: ${({ theme }) => theme.colors.Foreground};
    line-height: 24px;
    padding: 0;
    background-color: transparent;
    border: none;
    outline: transparent;
    caret-color: #59C3FF;
    &::-webkit-search-cancel-button {
        /* select all "X" buttons in search inputs */
        -webkit-appearance: none; /* hide the default "X" button */
        outline: none;
    }
    &:-webkit-autofill,
    &:-webkit-autofill:hover,
    &:-webkit-autofill:focus,
    &:-webkit-autofill:active {
        -webkit-box-shadow: 0 0 0 30px white inset !important;
    }
`;

const PlaceholderText = styled(SearchSuggestions)`
    pointer-events: none;
    position: absolute;
    max-width: calc(100% - 26px);
    top: 14px;
    left: 20px;
    height: 100%;
    white-space: nowrap;
    overflow: hidden;
`;

const CloseButton = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 48px;
    height: 48px;
    cursor: pointer;
    ${({ theme }) => theme.superQuery.all.and.minWidth.tabletMin.css`
        ${transition('all', 'medium-desktop', 'standard')};
    `};
    position: absolute;
    right: 0px;
    top: 0px;
    visibility: hidden;
    opacity: 0;
    ${({ visible }) => visible && css`
        visibility: visible;
        opacity: 1;
    `}
`;

const SearchContent = styled(ExpandedContent)`
    width: 100%;
    max-height: 0vh;
    display: none;
    ${({ visible }) => visible && css`
        display: block;
        max-height: 70vh;
        overflow-y: auto;
        padding-bottom: 16px;
        ${({ theme }) => theme.superQuery.all.and.maxWidth.mobileMax.css`
            max-height: unset;
            height: 100vh;
            padding-bottom: 192px;
        `};
    `}
`;

export {
    OuterWrap,
    InnerWrap,
    Form,
    Input,
    PlaceholderText,
    CloseButton,
    SearchContent,
};
